import { SxProp } from '../../internal/styles/sx';
import { RawMoneyProps } from '../RawMoney';

export interface MoneyFormatterProps {
  rounded?: boolean;
  currency: string;
  styled: boolean;
}

export type TokenFormat = {
  value: string;
  type: string;
} | null;

export const moneySizes = ['medium', 'small', 'tiny'] as const;
type MoneySizes = (typeof moneySizes)[number];

export const moneyTypes = ['none', 'link', 'positive', 'negative'] as const;
type MoneyTypes = (typeof moneyTypes)[number];

export interface MoneyProps extends SxProp, RawMoneyProps {
  rounded?: boolean;
  size?: MoneySizes;
  type?: MoneyTypes;
}
